import 'reflect-metadata';
import mixpanel from 'mixpanel-browser';
import { Exclude, Expose, plainToClass, Type } from 'class-transformer';
import {
    MarketingInfo,
    TradingPlatformAccountBalance,
    TradingPlatformAccountInfo,
} from 'services/generatedClientFromSwagger/models';
import { ThemeOptions } from 'interfaces/main';
import { getAppPathName, getSearchParams } from './urlParamaters';
import config from 'config/common';
import { ReviewedMixpanelEvents } from './mixpanelReviewedEvents';

let mixPanelInitial: string = '';
let userId: string = '';

export enum mixPanelEventsTypes {
    REGISTER_LOCAL = 'registerLocal',
    REGISTER_SOCIAL = 'registerSocial',
    AUTO_LOGIN = 'autoLogin',
    CHANGE_SELECTED_TP = 'changeTradingPlatform',
    WITHDRAW_REQUEST = 'withdrawRequest',
    TRANSFER_BETWEEN_ACCOUNTS_REQUEST = 'transferBetweenAccountsRequest',
    CREATE_NEW_TP = 'createNewTp',
    TP_ACCOUNT_BALANCE = 'tpAccountBalance',
    RATES_CLICK_EVENT = 'ratesClickEvent',
    CLICK_PROMOTION_BUTTON = 'clickPromotionButton',
    WHATS_APP_OPEN = 'openWhatsAppHelper',
    WHATS_APP_HIDE_BTN = 'hideWhatsAppBtn',
    TOUR_GUIDE_START_BTN_CLICK = 'TourGuideStartButtonClick',
    CLICK_ON_T4P_SIGNAL = 'ClickOnT4PSignal',
    CCS_SUBMIT_FOR_TRADE = 'ccsSubmitForTrade',
    DEBUG_WEBTRADER_ERROR = 'debugWebtraderError',
    NETWORK_CONNECTION = 'NetworkConnection',
    SUMSUB_EVENTS = 'SumsubEvents',
    PUSH_NOTIFICATION_PERMISSION_STATUS = 'PushNotificationPermissionStatus',
    PUSH_NOTIFICATION_OPEN_WINDOW = 'PushNotificationOpenWindow',
    PWA_INSTALLED = 'PWA Installed',
    CHAT_BASE_DRAWER_TOGGLE = 'ChatBaseDrawerToggle',
    PLAN_PURCHASE_DEPOSIT = 'planPurchaseDeposit',
    PAYOUT_DONE = 'payoutDone',
    PLAN_OUTSOURCE_DEPOSIT = 'planOutsourceDeposit',
    PROP_RETRY_TP_WITH_DISCOUNT = 'Prop_Retry_TP_with_Discount',
    PROP_RETRY_CHECKOUT_BACK_BTN = 'Prop_Retry_Checkout_Back_Btn',
    PROP_RETRY_MY_CHALLENGES = 'Prop_Retry_My_Challenges',
    PROP_RETRY_MODAL_RETRY_NOW = 'Prop_Retry_Modal_Retry_Now',
    PROP_RETRY_MODAL_RETRY_BACK = 'Prop_Retry_Modal_Retry_Back',
    PROP_RETRY_MODAL_RETRY_CLOSE = 'Prop_Retry_Modal_Retry_Close',
    PROP_RETRY_PAYMENT_SUCCESSFUL = 'Prop_Retry_Payment_Successful',
    LIGHT_DARK_MODE_CHANGE = 'lightDarkModeChange',
    PLAN_TAB_SELECTION = 'planTabSelection',
    LOGOUT = 'logout',
    NEW_CHALLENGE_FORM_CHANGE = 'New challenge form change',
    CHALLENGE_SELECTION = 'New challenge continue to checkout',
    CHECKOUT_PAGE_EVENTS = 'Checkout page events',
    CONTINUE_TO_PAYMENT = 'continueToPayment',
    PAYMENT_DONE = 'paymentDone',
    CLIENT_SUPPORT_REQUESTED = 'clientSupportRequested',
    INTERCOM_INITIATED = 'intercomInitiated',
    DOC_UPLOADED = 'docUploaded',
    PERSONAL_SETTINGS_UPDATE = 'personalSettingsUpdate',
    REQUEST_YOUR_PAYOUT = 'requestYourPayout',
    POPUP = 'popup',
    ERROR = 'error',
    PLAN_PAYOUT_WITHDRAW = 'planPayoutWithdraw',
    POSITIONS_VIEW = 'planTabSelection',
    DEPOSIT_DECLINED = 'depositDeclined',
    GENERIC_EVENT = 'genericEvent',
    KEEPER_ELIGIBLE_MODAL_APPEAR = 'keeperEligibleModalAppear',
    KEEPER_ELIGIBLE_MODAL_EXTEND_BTN = 'keeperEligibleModalExtendBtn',
    KEEPER_ELIGIBLE_MODAL_NOTNOW_BTN = 'KeeperEligibleModalNotNowBtn',
    KEEPER_ORDERPREVIEW_CONTINUETOPAYMENT = 'keeperOrderPreviewContinueToPayment',
    KEEPER_ACTIVATED_MODAL_CONTINUETRADING = 'keeperActivatedModalContinueTrading',
    KEEPER_ACTIVATED_MODAL_MYPLANS = 'keeperActivatedModalMyPlans',
    KEEPER_EXPIRED_MODAL_APPEAR = 'keeperExpiredModalAppear',
    KEEPER_EXPIRED_MODAL_STARTNEWCHALLENGE = 'keeperExpiredModalStartNewChallenge',
    KEEPER_EXPIRED_MODAL_VIEWDASHBOARD = 'keeperExpiredModalViewDashboard',
    KEEPER_TOAST_APPEAR = 'keeperToastAppear',
    KEEPER_TOAST_EXTENDMYLIMIT = ' keeperToastExtendMyLimit',
    KEEPER_TOAST_CLOSE = 'keeperToastClose',
    KEEPER_MY_CHALLENGES_BUTTON = 'keeperMyChallengesButton',
    PROP_MY_PURCHASES_PAGE = 'propMyPurchasesPage',
    KEEPER_WT_EXTENDMYLIMITBTN = 'keeperWTExtendMyLimitBtn',
    // RAF (Refer & Earn) events
    RAF_LINK_COPIED = 'rafLinkCopied',
    RAF_SOCIAL_SHARE_CLICKED = 'rafSocialShareClicked',
    RAF_TIME_FILTER_CHANGED = 'rafTimeFilterChanged',
    RAF_TOOLTIP_OPENED = 'rafTooltipOpened',
    RAF_TERMS_LINK_CLICKED = 'rafTermsLinkClicked',
    RAF_CTA_TRIGGERED = 'rafCtaTriggered',
    RAF_POPUP_ERROR = 'rafPopupError',
    RAF_POPUP_VIEWED = 'rafPopupViewed',
}

type mixPanelEventClasses =
    | MixPanelLocalRegister
    | MixPanelSocialRegister
    | MixPanelLogin
    | MixPanelUserLoggedIn
    | MixPanelAutoLogin
    | MixPanelDepositStarted
    | MixPanelDepositCompleted
    | MixPanelDepositFailed
    | MixPanelPageViewed
    | CreateNewTp
    | MixPanelWithdrawRequest
    | TPAccountBalace
    | RatesClickEvent
    | ClickPromotionButton
    | MixPanelCcsSubmitForTrade
    | MixPanelPushNotification
    | MixPanelDebugWebtraderError
    | MixPanelNetworkingMessage
    | MixPanelSumsubEvents
    | MixPaneInstallApp
    | MixPanelChatBaseDrawerToggle
    | MixPanelPlanPurchaseDeposit
    | MixPanelPlanPayoutWithdraw
    | MixPanelPlanOutsourceDeposit
    | MixPanelRetry
    | MixPanelPreferences
    | MixPanelMyPlans
    | MixPanelLogout
    | MixPanelChallengeSelect
    | MixPanelChallengeFormChange
    | MixPanelCheckoutPageEvents
    | MixPanelClientSupport
    | MixPanelIntercom
    | MixPanelFileUpload
    | MixPanelSettingsUpdate
    | MixPanelPayoutRequest
    | MixPanelError
    | MixPanelPayment
    | MixPanelContinueToPayment
    | MixPanelPaymentDone
    | MixPanelDepositDeclined
    | MixPanelIntercomInitiated
    | MixPanelRequestPayout
    | MixPanelDocUploaded
    | MixPanelPopup
    | MixPanelKeeper
    | MixPanelKeeperCheckout;

class MixPanelEvents {}

@Exclude()
class MixPaneInstallApp extends MixPanelEvents {}

@Exclude()
class MixPanelSumsubEvents extends MixPanelEvents {
    @Expose()
    type: string;
    @Expose()
    payload: {
        [key: string]: any;
    };
}

@Exclude()
class MixPanelCcsSubmitForTrade extends MixPanelEvents {
    @Expose()
    pair: string;
    @Expose({ name: 'volume' })
    amount: string;
    @Expose()
    price: string;
    @Expose()
    error: string;
}

@Exclude()
class MixPanelPushNotification extends MixPanelEvents {
    @Expose()
    permission_status: string;
}

@Exclude()
class ClickPromotionButton extends MixPanelEvents {
    @Expose()
    type: string;
}

@Exclude()
class RatesClickEvent extends MixPanelEvents {
    @Expose()
    clickOn: string;
    @Expose()
    symbol: string;
    @Expose()
    bid: number;
    @Expose()
    ask: number;
}

@Exclude()
class TPAccountBalace extends MixPanelEvents {
    @Expose()
    tpName: string;
    @Expose()
    balance: number;
}

@Exclude()
class CreateNewTp extends MixPanelEvents {
    @Expose()
    currency: string;
    @Expose()
    type: string;
}

@Exclude()
class MixPanelIntercomInitiated extends MixPanelEvents {
    @Expose()
    supportSubject: string;
}

@Exclude()
class MixPanelDocUploaded extends MixPanelEvents {
    @Expose()
    fileTypes: string[];
}

@Exclude()
class MixPanelWithdrawRequest extends MixPanelEvents {
    @Expose()
    tpId: string;
    @Expose()
    amount: string;
    @Expose()
    type: string;
}

@Exclude()
class MixPanelLocalRegister extends MixPanelEvents {
    @Expose()
    firstName: string;
    @Expose()
    lastName: string;
    @Expose()
    promoCode: string;
    @Expose()
    accountType: string;
    @Expose()
    status: boolean;
    @Expose()
    error: string;
}

@Exclude()
class MixPanelSocialRegister extends MixPanelEvents {
    @Expose()
    promoCode: string;
    @Expose()
    accountType: string;
    @Expose()
    socialType: string;
    @Expose()
    status: boolean;
    @Expose()
    error: string;
}

@Exclude()
class MixPanelLogin extends MixPanelEvents {
    @Expose()
    loginType: string;
    @Expose()
    status: boolean;
    @Expose()
    error: string;
}

@Exclude()
class MixPanelUserLoggedIn extends MixPanelEvents {
    @Expose()
    status: boolean;
    @Expose()
    error?: string;
}

@Exclude()
class MixPanelDepositStarted extends MixPanelEvents {
    @Expose()
    tpId: string;
    @Expose()
    tpName: string;
    @Expose()
    amount: string;
    @Expose()
    psp: string;
    @Expose()
    currency: string;
    @Expose()
    balance: string;
}

@Exclude()
class MixPanelDepositCompleted extends MixPanelEvents {
    @Expose()
    conditions: {};
    @Expose()
    status: boolean;
    @Expose()
    transactionId: string;
    @Expose()
    amount: number;
    @Expose()
    currency: string;
}

@Exclude()
class MixPanelPageViewed extends MixPanelEvents {
    @Expose()
    language: string;
    @Expose()
    theme: string;
}

@Exclude()
class MixPanelDepositFailed extends MixPanelEvents {
    @Expose()
    status: boolean;
    @Expose()
    transactionId: string;
    @Expose()
    amount: number;
    @Expose()
    currency: string;
}

@Exclude()
class MixPanelAutoLogin extends MixPanelEvents {
    @Expose()
    loginType: string;
    @Expose()
    status: boolean;
}

@Exclude()
class MixPanelChangeTP extends MixPanelEvents {
    @Expose()
    id: string;
    @Expose()
    currency: string;
    @Expose()
    type: string;
}

@Exclude()
class MixPanelUserInfo {
    @Expose()
    firstName: string;
    @Expose()
    lastName: string;
    @Expose({ name: 'dateOfBirth' })
    'Date of birth': string;
    @Expose()
    country: string;
    @Expose({ name: 'owningBusinessUnit' })
    'BU Name': string;
    @Expose()
    tradingPlatformAccounts?: TradingPlatformAccountInfo[];
    @Expose()
    accounts?: { [key: string]: TradingPlatformAccountBalance };
    @Expose()
    tpCount: number;
    @Expose()
    tpAccounts?: any[];
    @Expose()
    marketingInfo?: MarketingInfo;
    @Expose()
    featuresFlags?: Array<string>;
}

@Exclude()
class MixPanelClickOnT4pSignal extends MixPanelEvents {
    @Expose()
    id: string;
    @Expose()
    symbol: string;
    @Expose()
    rating: number;
}

@Exclude()
class MixPanelDebugWebtraderError extends MixPanelEvents {
    @Expose()
    failedToLoadIframe: boolean;
    @Expose()
    iframeUrl: string;
    @Expose()
    renewSSOCount: number;
    @Expose()
    iframeUrlLoading: boolean;
    @Expose()
    iframeReady: boolean;
}

@Exclude()
class MixPanelNetworkingMessage extends MixPanelEvents {
    @Expose()
    connectionStatus: string;
}
@Exclude()
class MixPanelChatBaseDrawerToggle extends MixPanelEvents {
    @Expose()
    action: 'open' | 'close';
}
@Exclude()
class MixPanelPreferences extends MixPanelEvents {
    @Expose()
    lightDarkMode: ThemeOptions;
}

@Exclude()
class MixPanelLogout extends MixPanelEvents {}

//@Exclude()
class MixPanelChallengeFormChange extends MixPanelEvents {}

//@Exclude()
class MixPanelCheckoutPageEvents extends MixPanelEvents {}

@Exclude()
class MixPanelChallengeSelect extends MixPanelEvents {
    @Expose()
    challengeType: 'real money' | 'free trial';
    @Expose()
    plan: string;
    @Expose()
    challengeAmount: string;
    @Expose()
    challengeFee: string;
}
@Exclude()
class MixPanelPayment extends MixPanelEvents {
    @Expose()
    challengeAmount: string;
    @Expose()
    plan: string;
    @Expose()
    paymentMethod: string;
    @Expose()
    discountCode: string;
    @Expose()
    errorCount: number;
}

@Exclude()
class MixPanelContinueToPayment extends MixPanelPayment {
    @Expose()
    challengeFee: string;
}

@Exclude()
class MixPanelPaymentDone extends MixPanelPayment {
    @Expose()
    auditionFee: string;
}

@Exclude()
class MixPanelDepositDeclined extends MixPanelPayment {
    @Expose()
    auditionFee: string;
}

@Exclude()
class MixPanelRequestPayout extends MixPanelPayment {
    @Expose()
    pendingAmount: number;
    @Expose()
    paidOutAmount: number;
    @Expose()
    withdrawableProfit: number;
}

@Exclude()
class MixPanelClientSupport extends MixPanelEvents {
    @Expose()
    supportSubject: string;
}
@Exclude()
class MixPanelIntercom extends MixPanelEvents {
    @Expose()
    pageName: string;
    @Expose()
    intercomeState: 'opened' | 'closed';
}

@Exclude()
class MixPanelFileUpload extends MixPanelEvents {
    @Expose()
    fileTypes: string[];
}

@Exclude()
class MixPanelSettingsUpdate extends MixPanelEvents {
    @Expose()
    settingChanged: string;
}

@Exclude()
class MixPanelPayoutRequest extends MixPanelEvents {
    @Expose()
    withdrawableProfit: string;
    @Expose()
    pendingAmount: string;
    @Expose()
    paidOutAmount: string;
}
@Exclude()
class MixPanelPopup extends MixPanelEvents {
    @Expose()
    popup: string;
}
@Exclude()
class MixPanelError extends MixPanelEvents {
    @Expose()
    errorMessage: string;
    @Expose()
    pageName: string;
}
@Exclude()
class MixPanelMyPlans extends MixPanelEvents {
    @Expose()
    tab: string;
}

@Exclude()
class MixPanelPlanPurchaseDeposit extends MixPanelEvents {
    @Expose()
    tpId: string;
    @Expose()
    tpName: string;
    @Expose()
    amount: string;
    @Expose()
    psp: string;
    @Expose()
    currency: string;
    @Expose()
    balance: string;
    @Expose()
    conditions: {};
    @Expose()
    type: string;
}

@Exclude()
class MixPanelPlanPayoutWithdraw extends MixPanelEvents {
    @Expose()
    tpId: string;
    @Expose()
    tpName: string;
    @Expose()
    payout: number;
    @Expose()
    psp: string;
    @Expose()
    currency: string;
    @Expose()
    balance: string;
    @Expose()
    type: string;
}

@Exclude()
class MixPanelPlanOutsourceDeposit extends MixPanelEvents {
    @Expose()
    tpId: string;
    @Expose()
    tpName: string;
    @Expose()
    amount: string;
    @Expose()
    psp: string;
    @Expose()
    currency: string;
    @Expose()
    balance: string;
    @Expose()
    type: string;
}

@Exclude()
class MixPanelRetry extends MixPanelEvents {
    @Expose()
    planType: string;
    @Expose()
    planPriceBeforeDiscount: string;
    @Expose()
    planPriceAfterDiscount: string;
    @Expose()
    discountAmount: string;
    @Expose()
    challengeAmount: string;
    @Expose()
    addOns: string;
    @Expose()
    conditionsValues: string;
}
@Exclude()
class MixPanelKeeper extends MixPanelEvents {
    @Expose()
    accountEmail: string;
    @Expose()
    planName: string;
    @Expose()
    keeperPrice: string;
    @Expose()
    conditionName: string;
    @Expose()
    originalValue: string;
    @Expose()
    newValue: string;
    @Expose()
    device: string;
}

@Exclude()
class MixPanelKeeperCheckout extends MixPanelEvents {
    @Expose()
    accountEmail: string;
    @Expose()
    planName: string;
    @Expose()
    keeperPrice: string[];
    @Expose()
    conditionName: string[];
    @Expose()
    originalValue: string[];
    @Expose()
    newValue: string[];
    @Expose()
    device: string;
}
export class mixPanelEventsPayload {
    @Type(() => MixPanelEvents, {
        discriminator: {
            property: '__type',
            subTypes: [
                {
                    value: MixPanelCcsSubmitForTrade,
                    name: mixPanelEventsTypes.CCS_SUBMIT_FOR_TRADE,
                },
                {
                    value: MixPanelLocalRegister,
                    name: mixPanelEventsTypes.REGISTER_LOCAL,
                },
                {
                    value: MixPanelSocialRegister,
                    name: mixPanelEventsTypes.REGISTER_SOCIAL,
                },
                {
                    value: MixPanelUserLoggedIn,
                    name: ReviewedMixpanelEvents.USER_LOGGED_IN,
                },
                {
                    value: MixPanelDepositStarted,
                    name: ReviewedMixpanelEvents.DEPOSIT_STARTED,
                },
                {
                    value: MixPanelDepositCompleted,
                    name: ReviewedMixpanelEvents.DEPOSIT_COMPLETED,
                },
                {
                    value: MixPanelPageViewed,
                    name: ReviewedMixpanelEvents.PAGE_VIEWED,
                },
                {
                    value: MixPanelDepositFailed,
                    name: ReviewedMixpanelEvents.DEPOSIT_FAILED,
                },
                {
                    value: MixPanelChangeTP,
                    name: mixPanelEventsTypes.CHANGE_SELECTED_TP,
                },
                {
                    value: MixPanelWithdrawRequest,
                    name: mixPanelEventsTypes.WITHDRAW_REQUEST,
                },
                {
                    value: CreateNewTp,
                    name: mixPanelEventsTypes.CREATE_NEW_TP,
                },
                {
                    value: TPAccountBalace,
                    name: mixPanelEventsTypes.TP_ACCOUNT_BALANCE,
                },
                {
                    value: RatesClickEvent,
                    name: mixPanelEventsTypes.RATES_CLICK_EVENT,
                },
                {
                    value: ClickPromotionButton,
                    name: mixPanelEventsTypes.CLICK_PROMOTION_BUTTON,
                },
                {
                    value: MixPanelAutoLogin,
                    name: mixPanelEventsTypes.AUTO_LOGIN,
                },
                {
                    value: MixPanelClickOnT4pSignal,
                    name: mixPanelEventsTypes.CLICK_ON_T4P_SIGNAL,
                },
                {
                    value: MixPanelPushNotification,
                    name: mixPanelEventsTypes.PUSH_NOTIFICATION_PERMISSION_STATUS,
                },
                {
                    value: MixPanelDebugWebtraderError,
                    name: mixPanelEventsTypes.DEBUG_WEBTRADER_ERROR,
                },
                {
                    value: MixPanelNetworkingMessage,
                    name: mixPanelEventsTypes.NETWORK_CONNECTION,
                },
                {
                    value: MixPanelSumsubEvents,
                    name: mixPanelEventsTypes.SUMSUB_EVENTS,
                },
                {
                    value: MixPaneInstallApp,
                    name: mixPanelEventsTypes.PWA_INSTALLED,
                },
                {
                    value: MixPanelChatBaseDrawerToggle,
                    name: mixPanelEventsTypes.CHAT_BASE_DRAWER_TOGGLE,
                },
                {
                    value: MixPanelPlanPurchaseDeposit,
                    name: mixPanelEventsTypes.PLAN_PURCHASE_DEPOSIT,
                },
                {
                    value: MixPanelPlanPayoutWithdraw,
                    name: mixPanelEventsTypes.PAYOUT_DONE,
                },
                {
                    value: MixPanelPlanOutsourceDeposit,
                    name: mixPanelEventsTypes.PLAN_OUTSOURCE_DEPOSIT,
                },
                {
                    value: MixPanelRetry,
                    name: mixPanelEventsTypes.PROP_RETRY_TP_WITH_DISCOUNT,
                },
                {
                    value: MixPanelRetry,
                    name: mixPanelEventsTypes.PROP_RETRY_CHECKOUT_BACK_BTN,
                },
                {
                    value: MixPanelRetry,
                    name: mixPanelEventsTypes.PROP_RETRY_MY_CHALLENGES,
                },
                {
                    value: MixPanelRetry,
                    name: mixPanelEventsTypes.PROP_RETRY_MODAL_RETRY_NOW,
                },
                {
                    value: MixPanelRetry,
                    name: mixPanelEventsTypes.PROP_RETRY_MODAL_RETRY_BACK,
                },
                {
                    value: MixPanelRetry,
                    name: mixPanelEventsTypes.PROP_RETRY_MODAL_RETRY_CLOSE,
                },
                {
                    value: MixPanelRetry,
                    name: mixPanelEventsTypes.PROP_RETRY_PAYMENT_SUCCESSFUL,
                },
                {
                    value: MixPanelPreferences,
                    name: mixPanelEventsTypes.LIGHT_DARK_MODE_CHANGE,
                },
                {
                    value: MixPanelMyPlans,
                    name: mixPanelEventsTypes.PLAN_TAB_SELECTION,
                },
                {
                    value: MixPanelLogin,
                    name: mixPanelEventsTypes.LOGOUT,
                },
                {
                    value: MixPanelChallengeSelect,
                    name: mixPanelEventsTypes.CHALLENGE_SELECTION,
                },
                {
                    value: MixPanelChallengeFormChange,
                    name: mixPanelEventsTypes.NEW_CHALLENGE_FORM_CHANGE,
                },
                {
                    value: MixPanelCheckoutPageEvents,
                    name: mixPanelEventsTypes.CHECKOUT_PAGE_EVENTS,
                },
                {
                    value: MixPanelPaymentDone,
                    name: mixPanelEventsTypes.PAYMENT_DONE,
                },
                {
                    value: MixPanelContinueToPayment,
                    name: mixPanelEventsTypes.CONTINUE_TO_PAYMENT,
                },
                {
                    value: MixPanelDepositDeclined,
                    name: mixPanelEventsTypes.DEPOSIT_DECLINED,
                },
                {
                    value: MixPanelIntercomInitiated,
                    name: mixPanelEventsTypes.INTERCOM_INITIATED,
                },
                {
                    value: MixPanelSettingsUpdate,
                    name: mixPanelEventsTypes.PERSONAL_SETTINGS_UPDATE,
                },
                {
                    value: MixPanelDocUploaded,
                    name: mixPanelEventsTypes.DOC_UPLOADED,
                },

                {
                    value: MixPanelRequestPayout,
                    name: mixPanelEventsTypes.REQUEST_YOUR_PAYOUT,
                },
                {
                    value: MixPanelPopup,
                    name: mixPanelEventsTypes.POPUP,
                },
                {
                    value: MixPanelKeeper,
                    name: mixPanelEventsTypes.KEEPER_ELIGIBLE_MODAL_APPEAR,
                },
                {
                    value: MixPanelKeeper,
                    name: mixPanelEventsTypes.KEEPER_ELIGIBLE_MODAL_EXTEND_BTN,
                },
                {
                    value: MixPanelKeeper,
                    name: mixPanelEventsTypes.KEEPER_ELIGIBLE_MODAL_NOTNOW_BTN,
                },
                {
                    value: MixPanelKeeperCheckout,
                    name: mixPanelEventsTypes.KEEPER_ORDERPREVIEW_CONTINUETOPAYMENT,
                },
                {
                    value: MixPanelKeeper,
                    name: mixPanelEventsTypes.KEEPER_ACTIVATED_MODAL_CONTINUETRADING,
                },
                {
                    value: MixPanelKeeper,
                    name: mixPanelEventsTypes.KEEPER_ACTIVATED_MODAL_MYPLANS,
                },
                {
                    value: MixPanelKeeper,
                    name: mixPanelEventsTypes.KEEPER_EXPIRED_MODAL_STARTNEWCHALLENGE,
                },
                {
                    value: MixPanelKeeper,
                    name: mixPanelEventsTypes.KEEPER_EXPIRED_MODAL_VIEWDASHBOARD,
                },
                {
                    value: MixPanelKeeper,
                    name: mixPanelEventsTypes.KEEPER_TOAST_APPEAR,
                },
                {
                    value: MixPanelKeeper,
                    name: mixPanelEventsTypes.KEEPER_TOAST_EXTENDMYLIMIT,
                },
                {
                    value: MixPanelKeeper,
                    name: mixPanelEventsTypes.KEEPER_TOAST_CLOSE,
                },

                {
                    value: MixPanelKeeper,
                    name: mixPanelEventsTypes.KEEPER_MY_CHALLENGES_BUTTON,
                },
                {
                    value: MixPanelKeeper,
                    name: mixPanelEventsTypes.PROP_MY_PURCHASES_PAGE,
                },
                {
                    value: MixPanelKeeper,
                    name: mixPanelEventsTypes.KEEPER_WT_EXTENDMYLIMITBTN,
                },
            ],
        },
    })
    payload: mixPanelEventClasses;
}

export const track = (type: mixPanelEventsTypes | ReviewedMixpanelEvents, payload: any = null) => {
    let data = { payload: {} };
    if (payload) {
        data = plainToClass(mixPanelEventsPayload, {
            payload: { __type: type, ...payload },
        });
    }
    const endpoint = getAppPathName();
    const searchParams = getSearchParams();
    const mixpanelPayload = {
        ...data.payload,
        endpoint,
        userId,
        searchParams,
    };
    mixpanel.track(type, mixpanelPayload);
};

export const identify = (accountId: string) => {
    if (mixPanelInitial === accountId) return;
    userId = accountId || '';
    if (!mixPanelInitial) {
        init(accountId);
    }
    if (!mixPanelInitial) return;

    mixpanel.identify(accountId);
};

export const setPeople = (payload: {}) => {
    if (!mixPanelInitial) return;
    let data = plainToClass(MixPanelUserInfo, payload);

    Object.keys(data).forEach((key) => data[key] === undefined && delete data[key]);

    const tps = data?.tradingPlatformAccounts?.map((tp) => tp.name);

    const tpCount = data?.tradingPlatformAccounts?.length;

    const arrayOfFeaturesFlags = Object.keys(config?.featuresFlags).filter((ff) => {
        return config?.featuresFlags[ff] === true;
    });

    data = {
        ...data,
        ...(tps && { tpAccounts: tps }),
        ...(tpCount && { tpCount }),
        featuresFlags: arrayOfFeaturesFlags,
    };

    if (data.marketingInfo) {
        data = { ...data, ...data.marketingInfo };
        delete data.marketingInfo;
    }

    delete data.accounts;
    delete data.tradingPlatformAccounts;

    mixpanel.people.set(data, (...args) => {
        console.log('mixpanel callback', args);
    });
};

export const init = (mixpanelKey: string) => {
    if (mixpanelKey) {
        mixpanel.init(mixpanelKey);
    }
};

const mixPanelExport = {
    track,
    identify,
    setPeople,
    init,
};

export default mixPanelExport;
